"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@chakra-ui/react");
var WikiIcon = function () { return (react_1.default.createElement(react_2.Box, { w: 4, h: 4, bg: "blueGray.700", borderRadius: "sm", display: "inline-flex", alignItems: "center", justifyContent: "center", lineHeight: "1" },
    react_1.default.createElement(react_2.Text, { fontSize: "0.5rem", fontWeight: "bold", color: "white", textTransform: "lowercase" }, "wk"))); };
exports.default = WikiIcon;
